import React, { useState, useEffect } from 'react'
import { Modal, Form, App, Radio } from 'antd'     
import { useDingdanzhichuZFLXMutation } from '../../store/DianShangYeWuApi'
import Icon from '../../cpn/Icon'
function CostFinanceZFLX(props) {
  const { message } = App.useApp()
  const [open, setOpen] = useState(false)
  const [info, setInfo] = useState({
    ddzc_id:props.ddzc_id,
    ddzc_zflx:props.ddzc_zflx,
  })
  const [form] = Form.useForm()
  const [updateSave] = useDingdanzhichuZFLXMutation()
  useEffect(() => {
    form.setFieldsValue({
        ddzc_zflx:props.ddzc_zflx,
    })
  }, [props.ddzc_zflx, form])
  return (
    <>
        <Icon type='financeZFLX' onClick={() => setOpen(true)} />
        <Modal
            title='财务改往来'
            open={open}
            onCancel={() => setOpen(false)}
            onOk={() => {
                updateSave({
                    ddzc_id:props.ddzc_id,
                    ddzc_zflx:info.ddzc_zflx,
                }).then((res) => {
                    if(res.data.Status === 'success') {
                        message.success('财务改往来成功！')
                        setOpen(false)
                    } else {
                        message.error('财务改往来失败！'+res.data.Message)
                    }
                }).catch((err) => {
                    message.error('财务改往来失败！'+err.message)
                })
            }}
        >
            <Form form={form} labelCol={{ span: 4 }} wrapperCol={{ span: 16 }}>
                <Form.Item label='往来类型' name='ddzc_zflx' rules={[{ required: true, message: '请选择往来类型' }]}>
                    <Radio.Group onChange={(e) => {
                        setInfo(prev => ({ ...prev, ddzc_zflx: e.target.value }))
                    }}>
                        <Radio value='现付'>现付</Radio>
                        <Radio value='应付'>应付</Radio>
                        <Radio value='核销应付'>核销应付</Radio>
                    </Radio.Group>
                </Form.Item>
            </Form>
        </Modal>
    </>
  )
}

export default CostFinanceZFLX